import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'my-documents',
  children: {
    list: {
      path: 'list',
      children: {
        new: {
          path: 'new',
        },
        documentId: {
          path: ':document_id',
        },
      },
    },
    companyFiles: {
      path: 'company-files',
      children: {
        list: {
          path: 'list',
          children: {
            documentId: {
              path: ':document_id',
            },
          },
        },
        folderId: {
          level: 2,
          path: ':folderId',
          children: {
            documentId: {
              level: 2,
              path: ':document_id',
            },
          },
        },
      },
    },
    folderId: {
      level: 2,
      path: ':folderId',
      children: {
        new: {
          level: 2,
          path: 'new',
        },
        documentId: {
          level: 2,
          path: ':document_id',
        },
      },
    },
  },
} as const satisfies Location
